const GIPHY_URL = 'https://api.giphy.com/v1/gifs/search';
const API_KEY = 'CdRKiCMbTnt9CkZTZ0lGukSczk6iT4Z6';
const DEFAULT_QUERY = {
  limit: 24,
  offset: 0,
  rating: 'G',
  lang: 'en',
};

export {
  GIPHY_URL,
  API_KEY,
  DEFAULT_QUERY,
}